import { render, staticRenderFns } from "./AddDetection.vue?vue&type=template&id=8a22aaa8"
import script from "./AddDetection.vue?vue&type=script&lang=js"
export * from "./AddDetection.vue?vue&type=script&lang=js"
import style0 from "./AddDetection.vue?vue&type=style&index=0&id=8a22aaa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports